const getSecondsUntil = (date?: string | null) => {
  if (!date) return undefined;

  const remaining = new Date(date).getTime() - Date.now();
  if (!Number.isFinite(remaining) || remaining <= 0) return undefined;

  return Math.floor(remaining / 1000);
};

export default getSecondsUntil;
